var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye-crossed",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.322,
    viewBox: "0 0 20 18.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "eye-crossed-2",
    "data-name": "eye-crossed",
    d: "M19.385,8.014a13.217,13.217,0,0,0-2.808-3.256l2.332-2.332a.833.833,0,1,0-1.178-1.178l-2.536,2.54A10.041,10.041,0,0,0,10,2.379,11.035,11.035,0,0,0,.607,8.014a4.088,4.088,0,0,0,0,4.3A13.217,13.217,0,0,0,3.415,15.57L1.082,17.9A.833.833,0,1,0,2.26,19.081L4.8,16.538A10.041,10.041,0,0,0,10,17.948a11.035,11.035,0,0,0,9.389-5.635A4.088,4.088,0,0,0,19.385,8.014ZM2.026,11.442a2.431,2.431,0,0,1,0-2.556A9.43,9.43,0,0,1,10,4.045a8.414,8.414,0,0,1,3.97.97L12.289,6.693a4.158,4.158,0,0,0-5.765,5.765L4.6,14.381a11.432,11.432,0,0,1-2.574-2.94Zm10.469-1.278a2.5,2.5,0,0,1-2.5,2.5,2.458,2.458,0,0,1-1.07-.25l3.32-3.32A2.458,2.458,0,0,1,12.495,10.164Zm-5,0a2.5,2.5,0,0,1,2.5-2.5,2.458,2.458,0,0,1,1.07.25l-3.32,3.32a2.458,2.458,0,0,1-.25-1.07Zm10.469,1.278A9.43,9.43,0,0,1,10,16.282a8.414,8.414,0,0,1-3.97-.97L7.7,13.635A4.158,4.158,0,0,0,13.467,7.87l1.924-1.924a11.432,11.432,0,0,1,2.574,2.94,2.431,2.431,0,0,1,0,2.556Z",
    transform: "translate(0.005 -1.003)",
    fill: "#414752",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0.004 -1.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67891",
    "data-name": "Path 67891",
    d: "M19.385,8.29A11.032,11.032,0,0,0,10,2.655,11.032,11.032,0,0,0,.607,8.29a4.088,4.088,0,0,0,0,4.3A11.032,11.032,0,0,0,10,18.224a11.032,11.032,0,0,0,9.389-5.635A4.088,4.088,0,0,0,19.385,8.29Zm-1.42,3.428A9.425,9.425,0,0,1,10,16.558a9.425,9.425,0,0,1-7.969-4.841,2.431,2.431,0,0,1,0-2.556A9.425,9.425,0,0,1,10,4.321a9.418,9.418,0,0,1,7.969,4.841A2.431,2.431,0,0,1,17.964,11.717Z",
    transform: "translate(0 0)",
    fill: "#414752"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67892",
    "data-name": "Path 67892",
    d: "M12,7C9.239,7,7,8.54,7,10.44s2.239,3.44,5,3.44,5-1.54,5-3.44S14.76,7,12,7Zm0,5.5c-1.657,0-3-.924-3-2.064s1.343-2.064,3-2.064,3,.924,3,2.064S13.657,12.5,12,12.5Z",
    transform: "translate(-2.004)",
    fill: "#414752"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.1deab52034a42bbccb845e5c056ef9a8.svg";
export { ForwardRef as ReactComponent };